import { Component } from '@angular/core';

import { Observable } from 'rxjs';
import { DeploymentFrequencyCalculatorService } from '../../services/deployment-frequency-calculator.service';
import { TeamMetricsService } from '../../services/team-metrics.service';
import { DeploymentFrequencyResult } from '../../models/team-metrics';
import { MetricCardComponent } from '../metric-card/metric-card.component';
import { BaseMetricComponent } from './base-metric.component';

@Component({
  selector: 'app-deployment-frequency-metric',
  standalone: true,
  imports: [MetricCardComponent],
  template: `
    <app-metric-card
      title="Deployment Frequency"
      icon="rocket_launch"
      [metricData]="metricDataToDisplay"
      metricType="deploymentFrequency"
      [isLoading]="isLoading || (isOtherMetricLoading ?? false)"
      tooltipText="Total number of releases within the selected time period">
    </app-metric-card>
  `
})
/**
 * Component to display the Deployment Frequency metric.
 * It extends BaseMetricComponent to leverage common metric functionalities.
 */
export class DeploymentFrequencyMetricComponent extends BaseMetricComponent<DeploymentFrequencyResult> {
  
  /**
   * Constructs the DeploymentFrequencyMetricComponent.
   * @param dfCalculatorService Service to calculate deployment frequency.
   * @param teamMetricsService Service for shared team metrics functionalities.
   */
  constructor(
    private readonly dfCalculatorService: DeploymentFrequencyCalculatorService,
    teamMetricsService: TeamMetricsService
  ) {
    super(teamMetricsService);
  }

  /**
   * Fetches the deployment frequency metric data.
   * This method is called by the base component to retrieve metric data.
   * @param team The team name for which to calculate the metric.
   * @param isoStartDate The start date of the period in ISO format.
   * @param isoEndDate The end date of the period in ISO format.
   * @param org The ADO organization name.
   * @param project The ADO project name.
   * @returns An Observable emitting the DeploymentFrequencyResult or null.
   */
  protected callFetchMetric(
    team: string, 
    isoStartDate: string, 
    isoEndDate: string,
    org: string,
    project: string
  ): Observable<DeploymentFrequencyResult | null> {
    return this.dfCalculatorService.calculate(team, isoStartDate, isoEndDate, org, project, true);
  }
}
